import crypto from "crypto"
import { Link } from "react-router-dom"
// import { l } from "./const"
// console.log("%c!", "color:white;padding:.5em;background-color: black;",  test)

const algorithm = "aes-256-ctr"
const key = "f28750bc0d89c7640d3bcf1b5d640dda"

export function encrypt(text: string) {
    var cipher = crypto.createCipheriv(algorithm, key, Buffer.alloc(16, 0))
    var crypted = cipher.update(text, "utf8", "hex")
    crypted += cipher.final("hex")
    return crypted
}

export function decrypt(text: string) {
    var decipher = crypto.createDecipheriv(algorithm, key, Buffer.alloc(16, 0))
    var dec = decipher.update(text, "hex", "utf8")
    dec += decipher.final("utf8")
    return dec
}

// type JSON = {[key : string ] : any } | {[key : string ] : any }[]
export function fetchJSON(url: string): Promise<string> {
    return window
        .fetch(url)
        .then((res) => res.json())
        .then((res) => res)
        .catch((err) => console.log(err))
}

// selects 1 item from an array randomly and returns it
export function selectRandomFromArray<T>(arr: T[]): T {
    return arr[Math.floor(Math.random() * arr.length)]
}

export function dayTime() {
    const hour = new Date().getHours()

    if (hour >= 6 && hour < 12) {
        return "dashboard_good-morning"
    } else if (hour >= 12 && hour < 15) {
        return "dashboard_good-noon"
    } else if (hour >= 15 && hour < 20) {
        return "dashboard_good-evening"
    } else return "dashboard_good-night"
}

export function removeNullFields(obj: Record<string, any>) {
    return Object.entries(obj).reduce((acc: Record<string, any>, curr) => {
        if (curr[1] !== null && curr[1] !== undefined) acc[curr[0]] = curr[1]
        return acc
    }, {})
}

export function convertPlaybackTime(seconds: any = "0") {
    seconds = parseInt(seconds)
    const minute = seconds / 60
    const second = seconds % 60
    return `${minute < 10 ? "0" + minute : minute}:${second < 10 ? "0" + second : second}`
}

type StringType = {
    to: string
}

export class EnhancedString extends String {
    constructor(public string: string) {
        super(string)
        this.string = string
    }
    // replace the ###variable### inside the <Link to={to}>variable</Link>
    Link({ to }: StringType): React.ReactNode {
        const input = this.string
        const [ignore, begining, linkPart, end]: string[] = input.match(/(.*)###(.+)###(.*)/im) as string[]
        return (
            <span>
                {begining}
                <Link to={to}>{linkPart}</Link>
                {end}
            </span>
        )
    }
    a({ to }: StringType) {
        const input = this.string
        const [ignore, begining, linkPart, end] = input.match(/(.*)###(.+)###(.*)/im) as string[]
        return (
            <span>
                {begining}
                <a href={to} target="_blank">
                    {linkPart}
                </a>
                {end}
            </span>
        )
    }
    p() {
        const input = this.string.split("###")
        return input.map((item, i) => <p key={i}>{item}</p>)
    }
    b() {
        const input = this.string
        const [ignore, begining, linkPart, end] = input.match(/(.*)##(.+)##(.*)/im) as string[]
        return (
            <span>
                {begining}
                <b>{linkPart}</b>
                {end}
            </span>
        )
    }
}

export function sanitizeHTML(string: any) {
    if (typeof string === "string") {
        return string.replace("<", " ").replace(">", " ")
    } else return ""
}

export function getQueries(string: string) : Record<string , string> {
    if (typeof string !== "string") throw Error("getQueries must have a string as argument")
    string = string.trim()
    string = string[0] === "?" ? string.slice(1) : string
    const pairs = string.split("&")
    const obj = pairs.reduce((acc, curr) => {
        const disect = curr.split("=")
        const newObj: Record<string, string> = {}
        newObj[disect[0]] = disect[1]
        return { ...acc, ...newObj }
    }, {})
    return obj
}

export function log(arg: any, color?: string): void {
    console.log("%c!", `color:white;padding:.5em;background-color: ${color ? color : "black"};`, arg)
}

export * from "./utils/graphqlRequests"